export default __webpack_public_path__ + "static/media/plurius.201a6d00.svg";